import React, { useContext } from "react";
import {
  Plan2PlateDrawer,
  Plan2PlateDrawerHeader,
  usePlan2PlateDisclosure,
} from "./Plan2PlateDrawer";
import { Plan2PlateIconButton } from "./buttons/Plan2PlateIconButton";
import { DrawerHistoryContext } from "../contexts";
import { deleteShoppingList } from "../api";
import { queryKeys, useShoppingList } from "../queries/queries";
import { useQueryClient } from "@tanstack/react-query";
import ShoppingListDrawerContent from "./shopping-list/ShoppingListDrawerContent";
import ShoppingListCreateDrawerContent from "./shopping-list/ShoppingListCreateDrawerContent";

function ShoppingDrawerBody({ onClose }: { onClose: () => void }) {
  const queryClient = useQueryClient();
  const shoppingList = useShoppingList();

  if (shoppingList.length === 0) {
    return (
      <ShoppingListCreateDrawerContent
        onCreated={() =>
          queryClient.invalidateQueries({ queryKey: queryKeys.shoppingList })
        }
      />
    );
  }

  return (
    <ShoppingListDrawerContent
      onFinish={async () => {
        await deleteShoppingList();
        await queryClient.invalidateQueries({
          queryKey: queryKeys.shoppingList,
        });
        onClose();
      }}
    />
  );
}

function ShoppingDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Plan2PlateDrawer
      open={open}
      onClose={onClose}
      header={<Plan2PlateDrawerHeader heading={"Einkaufsliste"} />}
      body={open ? <ShoppingDrawerBody onClose={onClose} /> : null}
    />
  );
}

export function ShoppingCartButton() {
  const drawerHistoryContext = useContext(DrawerHistoryContext);
  const { isOpen, onOpen, onClose } = usePlan2PlateDisclosure(
    drawerHistoryContext,
    "shopping",
  );
  return (
    <>
      <Plan2PlateIconButton
        data-cy="cart-button"
        aria-label={"Einkaufen"}
        title={"Einkaufen"}
        icon={"shopCart"}
        onClick={onOpen}
      />
      <ShoppingDrawer open={isOpen} onClose={onClose} />
    </>
  );
}
